class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector("[data-close]");
    this.content = this.querySelector(".size-guide__inner");

    this.addEventListener("click", (e) => {
      if (e.target.closest(".size-guide__inner")) return;

      this.close();
    });

    document.addEventListener("click", this.handleDocumentClick);

    this.closeEsc = (e) => {
      if (e.key === "Escape") {
        this.close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);
  }

  connectedCallback() {
    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.close();
    });

    document.addEventListener("size-guide:open", () => this.open());
    document.addEventListener("size-guide:close", () => this.close());
  }

  disconnectedCallback() {
    document.removeEventListener("keydown", this.closeEsc);
    document.removeEventListener("click", this.handleDocumentClick);
  }

  open() {
    if (this.hasAttribute("open")) return;
    this.style.display = "block";
    window.requestAnimationFrame(() => {
      this.setAttribute("open", "");
      window.openFullDimmer(this);
      window.lockScroll(this);
      this.returnFocusEl = document.activeElement;
      window.trapFocus(this, this.closeButton);
    });
  }

  close() {
    if (!this.hasAttribute("open")) return;
    this.removeAttribute("open");
    window.closeFullDimmer(this);

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);
      if (this.hasAttribute("open")) return;
      this.style.display = null;
      window.removeTrapFocus(this.returnFocusEl);
      window.unlockScroll(this);
    };

    this.addEventListener("transitionend", onEnd);
  }
}

if (!customElements.get("size-guide")) {
  customElements.define("size-guide", SizeGuide);
}

class SizeGuideTrigger extends HTMLElement {
  constructor() {
    super();
    this.openButton = this.querySelector(".size-guide__trigger");
  }

  connectedCallback() {
    this.openButton.addEventListener("click", (e) => {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent("size-guide:open"));
    });
  }
}

if (!customElements.get("size-guide-trigger")) {
  customElements.define("size-guide-trigger", SizeGuideTrigger);
}
